var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogobottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sygnet_vector",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 228,
    height: 236.993,
    viewBox: "0 0 228 236.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 228,
    height: 236.993,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M12.8,194.465a102.519,102.519,0,0,1,7.818-39.412l13.743,5.691,11.207,4.643a76.168,76.168,0,0,0,0,58.155,76.289,76.289,0,0,0,16.481,24.649L42.962,267.276A102.688,102.688,0,0,1,12.8,194.465",
    transform: "translate(-6.269 -75.968)",
    fill: "#eddea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M65.73,204.392A75.425,75.425,0,0,1,71.5,175.314l6.866,2.845,3.477,1.438,10.576,4.38,12.645,5.235L119.04,195a24.582,24.582,0,0,0,0,18.783l-13.976,5.788-12.645,5.235-10.576,4.38-3.477,1.437L71.5,233.469a75.464,75.464,0,0,1-5.769-29.078",
    transform: "translate(-32.204 -85.895)",
    fill: "#0fa3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M118.056,261.759l12.645-5.235,13.975-5.788a24.538,24.538,0,0,0,32.05,13.276l5.8,13.976,5.235,12.645a53.359,53.359,0,0,1-69.7-28.874",
    transform: "translate(-57.841 -122.848)",
    fill: "#eddea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M50.4,375.965l21.493-21.493a88.174,88.174,0,0,0,96.023,19.113l5.692,13.743,5.944,14.345A118.439,118.439,0,0,1,50.4,375.965",
    transform: "translate(-24.694 -173.673)",
    fill: "#d9e5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M71.938,60.594a102.688,102.688,0,0,1,72.811-30.166v27A75.465,75.465,0,0,0,115.671,63.2,76.262,76.262,0,0,0,91.022,79.668L82.447,71.1Z",
    transform: "translate(-35.246 -14.908)",
    fill: "#eddea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M269.663,152.665l9.683-9.683v-.01l8.1-8.09,7.915-7.915a76.079,76.079,0,0,1,16.472,82.815l-6.866-2.846L301.5,205.5l-10.576-4.38-12.654-5.235a39.618,39.618,0,0,0-8.605-43.219",
    transform: "translate(-132.121 -62.207)",
    fill: "#eddea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M233.1,131.447l5.789-13.975,5.235-12.655,4.38-10.576,1.438-3.467,2.846-6.866L257.431,72.7a88.089,88.089,0,0,1,28.583,19.113l-16.481,16.481-8.1,8.09v.01l-9.683,9.683L241.057,136.77a24.552,24.552,0,0,0-7.954-5.322",
    transform: "translate(-114.208 -35.619)",
    fill: "#d9e5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M358.109,188.755a75.435,75.435,0,0,0-5.769-29.078l11.208-4.643,13.743-5.691,14.344-5.944a118.861,118.861,0,0,1,0,90.711l-14.344-5.944-13.743-5.691-11.208-4.643a75.473,75.473,0,0,0,5.769-29.078",
    transform: "translate(-172.628 -70.259)",
    fill: "#d9e5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M233.084,264a24.559,24.559,0,0,0,13.286-13.286l13.976,5.8L273,261.75l10.576,4.38,3.467,1.437,6.867,2.846,11.207,4.642,13.743,5.691a103.321,103.321,0,0,1-55.747,55.747l-5.692-13.742-4.642-11.208-2.846-6.866L248.5,301.2l-4.38-10.576-5.235-12.645Z",
    transform: "translate(-114.199 -122.838)",
    fill: "#0fa3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M109.354,105.613v-.01A76.247,76.247,0,0,1,134,89.132a76.17,76.17,0,0,1,58.156,0L189.313,96l-1.437,3.467-4.38,10.576L178.261,122.7l-5.789,13.975a24.51,24.51,0,0,0-26.737,5.322L135.042,131.3l-9.683-9.683v-.01l-8.09-8.081v-.01l-2.661-2.651Z",
    transform: "translate(-53.578 -40.844)",
    fill: "#0fa3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M214.69,30.389V0a118.647,118.647,0,0,1,109.5,73.141l-14.344,5.944-13.743,5.691A88.06,88.06,0,0,0,214.69,30.389",
    transform: "translate(-105.187)",
    fill: "#0fa3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M92.541,330.859l24.581-24.581A53.324,53.324,0,0,0,154.844,321.9v34.76a87.937,87.937,0,0,1-62.3-25.805",
    transform: "translate(-45.34 -150.06)",
    fill: "#0fa3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M0,106.484a118.429,118.429,0,0,1,25.717-38.43L47.2,89.537,55.776,98.1v.01l5.254,5.254,2.661,2.651v.01l8.09,8.081v.01l9.683,9.683a39.717,39.717,0,0,0-8.6,12.858l-12.645-5.235-10.576-4.38-3.477-1.437-6.866-2.846-11.208-4.643-13.742-5.691Z",
    transform: "translate(0 -33.343)",
    fill: "#d9e5d7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogobottom);
export default __webpack_public_path__ + "static/media/logobottom.3fc7eab1fbf144f27c0f637a84dcd252.svg";
export { ForwardRef as ReactComponent };